import Api from '../baseApi'

export default {
  async fetchAll() {
    return await Api.get(`/api-article/summary-additions/v1`);
  },
  async fetch(id) {
    return await Api.get(`/api-article/summary-additions/v1/${id}`);
  },
  async create(data) {
    return await Api.post('/api-article/summary-additions/v1', data);
  },
  async update(data) {
    return await Api.put('/api-article/summary-additions/v1', data);
  },
  async delete(id) {
    return await Api.delete(`/api-article/summary-additions/v1/${id}`);
  },
  async copy(id) {
    return await Api.post(`/api-article/summary-additions/v1/copy`, {summaryAdditionId: id});
  }
}
